// @ts-ignore
import initApis from './apis.js';
import vHttp from './vHttp';
import {RequestConfig} from "./vHttpInterface";
import {HttpResponseInterface, HttpParamsInterface} from '../utils/responseUtil';


interface InitAPIInterface {
  uri: string,
  pageId: string,
  page_uri: string,
  title: string,
  type: 'GET' | 'POST' | 'PUT' | 'DELETE'| 'POSTFORM'
}

interface APIInterface {
  [k: string]: (params: HttpParamsInterface, config?: RequestConfig) => Promise<HttpResponseInterface>
}


const apis: APIInterface = {};
for (let k in initApis) {
  // @ts-ignore
  const item: InitAPIInterface = initApis[k];
  const methods = {
    'GET': vHttp.get,
    'POST': vHttp.post,
    'DELETE': vHttp.delete,
    'PUT': vHttp.put,
    'POSTFORM': vHttp.postForm,
  };
  apis[k] = (params: HttpParamsInterface, config?: RequestConfig) => {
    // @ts-ignore
    const vHost = config?.host || window.config.host;

    let url = vHost + item.uri.replace(/\{.+\}/, params.id) + '?payType=web';
    const regex = /\{([^}]+)\}/;
    if (item.uri.match(regex)) {
      url = url.replace(/\{.+\}/, params.id);
    }
   for (let key in params) {
     if(key === 'pIdx'){
       params[key] = params[key] - 1
     }
   }

    return methods[item.type](url, params, config);
  };
}

export default apis;

